import tw from 'twin.macro';

export const TeamContainer = tw.div`py-24 sm:py-28`;
export const TeamHeader = tw.h2`text-5xl tracking-tight text-center mb-5`;
export const TeamWrapper = tw.div`flex flex-wrap mx-auto max-w-7xl px-6 lg:px-8`;
export const TeamCard = tw.div`mx-auto my-3 bg-white border rounded shadow max-w-sm flex-1 basis-1/3`;
export const TeamImage = tw.img`w-full object-cover max-h-64`;
export const TeamCardContent = tw.div`p-4 text-center`;
export const TeamName = tw.h3`text-3xl text-black`;
export const TeamRole = tw.p`font-semibold uppercase`;
